// ts-check
import React from 'react';
import PageList from '../../../components/PageListAPI'
import * as api from '../../../api/list'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function Machine(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='Machine'
        title='Техника'
        columns={[
          { id: 'govNumber', name: 'Гос. номер', width: 150 },
          { id: 'model', name: 'Модель' },
        ]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        loadAPI={{
          request: api.getMachine,
        }}
        deleteAPI={api.deleteMachine}
        {...props}
      />
    </div>
  )
}